import * as brandColors from '../../../../utils/brand-colors';

export default () => ({
  status: {
    margin: 0,
    fontSize: '13px',
    fontWeight: 400,
    color: brandColors.grey[500],
  },
  statusIcon: { margin: '0 1em 0 0' },
  cardHeader: { alignItems: 'flex-start' },
  cardHeaderSubheader: { lineHeight: 1.1 },
  eventUploadContainer: { marginBottom: 8 },
  noPageHeaderTabContainer: {
    background: '#00acc1',
    color: 'white',
  },
  eventName: {
    margin: 0,
    fontWeight: 300,
    fontSize: '1.2em',
  },
  buttonContainer: {
    textAlign: 'right',
    margin: 8,
  },
  hidden: { display: 'none' },
  statContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 6,
  },
  statIcon: {
    color: '#e0e0e0',
    fontSize: 16,
    marginRight: 2,
  },
  overdueChip: { marginLeft: 6 },
  eventIdField: { color: brandColors.grey[500] },
});
